import { render } from "./MyChats.vue?vue&type=template&id=39c86c68"
import script from "./MyChats.vue?vue&type=script&lang=js"
export * from "./MyChats.vue?vue&type=script&lang=js"

import "./MyChats.vue?vue&type=style&index=0&id=39c86c68&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__